import { Injectable, inject } from '@angular/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Platform } from '@ionic/angular/standalone';
import { AuthService } from './auth.service';
import { BehaviorSubject } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { Firestore, doc, getDoc, updateDoc, setDoc } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {
  private fcmToken = new BehaviorSubject<string | null>(null);
  public fcmToken$ = this.fcmToken.asObservable();

  private firestore = inject(Firestore);

  constructor(
    private platform: Platform,
    private authService: AuthService
  ) { }

  async createNotificationChannel() {
    if (Capacitor.getPlatform() === 'android') {
      await PushNotifications.createChannel({
        id: 'eugloh_channel',
        name: 'EUGLOH Notifications',
        description: 'Notifications from EUGLOH Connect',
        importance: 4,
        visibility: 1,
        lights: true,
        vibration: true
      });
    }
  }

  async initPushNotifications() {
    if (!this.platform.is('capacitor')) {
      return;
    }

    try {
      const permStatus = await PushNotifications.requestPermissions();

      if (permStatus.receive === 'granted') {
        
        await this.createNotificationChannel();
        
        await PushNotifications.register();

        PushNotifications.addListener('registration', async (token) => {
          this.fcmToken.next(token.value);
          await this.saveTokenToFirestore(token.value);
        });

        PushNotifications.addListener('registrationError', (error: any) => {
          console.error('[PushService] Error on push registration: ' + JSON.stringify(error));
        });

      } else {
        console.warn('[PushService] Push notification permission was not granted.');
      }
    } catch (error) {
      console.error('[PushService] A critical error occurred during initPushNotifications:', error);
    }
  }

  private async saveTokenToFirestore(token: string) {
    try {
      const user = this.authService.getCurrentUser();
      if (user && user.uid) {
        const userDocRef = doc(this.firestore, 'Users', user.uid);
        const userDocSnapshot = await getDoc(userDocRef);
        let tokens: string[] = [];

        if (userDocSnapshot.exists()) {
          const userData = userDocSnapshot.data();
          if (userData && userData['fcmTokens'] && Array.isArray(userData['fcmTokens'])) {
            tokens = [...userData['fcmTokens']];
          }
        }

        if (!tokens.includes(token)) {
          tokens.push(token);

          if (userDocSnapshot.exists()) {
            await updateDoc(userDocRef, { fcmTokens: tokens });
          } else {
            await setDoc(userDocRef, { fcmTokens: tokens }, { merge: true });
          }
        } else {
        }
      } else {
        console.warn('[PushService] No authenticated user found. Cannot save FCM token.');
      }
    } catch (error) {
      console.error('[PushService] Error saving token to Firestore:', error);
    }
  }
}